import axios from "axios";
import * as actionType from "../../constant/actionType";

export const GetAllProvidersOfClient = (apiData) => async (dispatch) => {
    /*** API Call Action ***/
    try {
      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        url: `${actionType.environment_url}/api/admin/client/GetAllProvidersOfClient`,
        params: apiData,
      });
      return response.data
    //   dispatch(fetchDataSuccess(response.data));
    } catch (error) {
        return error.message
    //   dispatch(fetchDataError(error.message));
    }
  };
  